const LISTE_DEMANDE_IMPRESSION = {
  title: 'Liste des demandes d\'impressions',
  tabs: {
    enseigne: 'Enseigne',
    campagne: 'Campagne',
    materielType: 'Matériel(s) type(s)',
    visuelCampagne: 'Visuel campagne',
    dateDemande: 'Date demande',
    etats: 'Etat(s)',
    quantite: 'Quantité',
    nombreDemande: 'Nombre de demandes',
    prisEnCharge: 'Pris en charge par',
    tabChildRow: {
      client: 'Client',
      date: 'Date demande',
      etat: 'Etat',
      demandeur: 'Contact demandeur',
      dispositif: 'Code dispositif',
      dispositifEtat: 'Etat dispositif',
      campagne: 'Campagne',
      adresse: 'Adresse dispositif',
      typeMateriel: 'Matériel(s) type(s)',
      createur: 'Créée par',
      quantite: 'Quantité',
      soldeStock: 'Solde stock',
      graphisteEnCharge: 'Pris en charge par',
    },
  },
  popUpAddImpression: {
    title: 'Création de demande(s) d\'impression',
    dateDemande: 'Date demande d\'impression',
    etat: 'Etat',
    couleur: 'Couleur',
    demandeur: 'Contact demandeur',
    receveur: 'Contact receveur',
    campagne: 'Campagne',
    quantite: 'Quantité',
    nomVariante: 'Nom variante',
    dateLimite: 'Date limite',
    tags: 'Tags',
  },
  actions: {
    newDemandeImpression: 'Nouvelle demande',
    editDemandeImpression: 'Modifier',
    search: 'Rechercher',
    creerOT: 'Créer OT',
    creerOTDisabled: 'L\'OT d\'impression est déjà crée',
    deleteOTDisabled: 'La demande est liée à un OT d\'impression',
    creationEditionOt: 'Création/édition OTs',
    updateCampagne: 'Modifier campagne',
    updateEtat: 'Modifier état',
    filterCurrentUser: 'Voir mes prises en charge',
    noFilterCurrentUser: 'Ne plus filtrer sur mes prises en charge',
    updateNomFichierRip: 'Modifier nom du fichier',
    updateGraphiste: 'Modifier graphiste en charge',
    updateDate: 'Modifier date de demande',
    updateQuantite: 'Modifier quantité',
  },
  breadcrumb: {
    home: 'Accueil',
    listeDemandeImpression: 'Liste des demandes d\'impressions',
  },
  filtre: {
    client: 'Client',
    date: 'Date demande',
    etat: 'Etat',
    couleurs: 'Couleur',
    demandeur: 'Contact demandeur',
    receveur: 'Contact receveur',
    dispositif: 'Dispositif',
    campagne: 'Campagne',
    graphiste: 'Pris en charge par',
    tag: 'Tag(s)',
    materielTypeLibelles: 'Matériel(s) type(s)',
  },
  bouton: {
    addDemandeImpression: 'Créer une demande d`\'impression',
  },
  popUpSuppression: 'Voulez vous vraiment supprimer cette demande',
  popUpCreationOt: 'Voulez vous vraiment un OT pour cette demande',
  popUpCreationEditionOt: {
    messHeader: 'Création et édition OTs',
    messDescription: 'Cette action va créer et éditer des OTs. Êtes-vous sûr de vouloir continuer ?',
  },
  popUpModificationCampagne: {
    title: 'Modification de la campagne',
  },
  popUpModificationNomFichier: {
    title: 'Modification du nom de fichier',
  },
  popUpModificationGraphiste: {
    title: 'Modification du graphiste en charge',
  },
  popUpModificationDate: {
    title: 'Modification de la date de demande',
  },
  popUpModificationQuantite: {
    title: 'Modification de la quantité',
  },
  popUpModificationEtat: {
    title: 'Modification de l\'état',
  },
  updateGraphiste: {
    action: 'Je prends en charge',
    popupTitle: 'Prise en charge de(s) demande(s) d\'impression',
    popupDescription: 'En effectuant cette action, vous serez le graphiste en charge de toutes les demandes de ce regroupement. Êtes-vous sûr de vouloir continuer ?',
    messageSuccess: 'La prise en charge a bien été effectuée',
  },
};

export default LISTE_DEMANDE_IMPRESSION;
